export default __webpack_public_path__ + "static/media/target-11@3x.9c7b034a.png";